import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faCircleDot } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { gql } from '@soundxyz/gql-string';
import { ReleaseCoverImagePlayButton } from '@components/basics/ReleaseCoverImagePlayButton';
import type {
  FeedPostModalMainSoundFragment,
  FragmentType,
  ReleaseCoverImagePlayButtonFragmentDoc,
} from '@graphql/reactQuery';
import { FeedPostModalMainSoundFragmentDoc } from '@graphql/reactQuery';
import { FeedPostModalSoundSelectItemFragmentDoc, getFragment } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment FeedPostModalSoundSelectItem on Release {
    id
    track {
      id
      title
    }
    title
    artist {
      id
      name
    }
  }
`);

export function FeedPostModalSoundSelectItem({
  releaseFrag,
  selected,
  onReleaseSelected,
}: {
  releaseFrag: FragmentType<FeedPostModalSoundSelectItemFragmentDoc> &
    FragmentType<ReleaseCoverImagePlayButtonFragmentDoc> &
    FragmentType<FeedPostModalMainSoundFragmentDoc>;
  selected: boolean;
  onReleaseSelected: (release: FeedPostModalMainSoundFragment) => void;
}) {
  const release = getFragment(FeedPostModalSoundSelectItemFragmentDoc, releaseFrag);

  return (
    <div
      className="mx-2 flex cursor-pointer items-center gap-2 rounded-md px-2 py-2 hover:bg-neutral50 lt:mx-4"
      onClick={() => {
        onReleaseSelected(getFragment(FeedPostModalMainSoundFragmentDoc, releaseFrag));
      }}
      tabIndex={0}
    >
      <ReleaseCoverImagePlayButton releaseFrag={releaseFrag} />
      <div className="flex flex-1 flex-col justify-center gap-1">
        <div className="line-clamp-1 font-title text-title-xxs font-medium text-neutral700">
          {release.title}
        </div>
        <div className="line-clamp-1 text-base-s text-base500">{release.artist.name}</div>
      </div>

      <div className="h-5 w-5">
        {selected ? (
          <FontAwesomeIcon icon={faCircleDot} size="lg" className="text-base800" />
        ) : (
          <FontAwesomeIcon icon={faCircle} size="lg" className="text-base500" />
        )}
      </div>
    </div>
  );
}
